import { createFileRoute } from '@tanstack/react-router'
import { SavedPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/gespeichert')({
  head: () => noIndexRouteHead('saved', 'de'),
  component: SavedPage,
})
